import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface MountAndHideProps {
  show: boolean;
  children: React.ReactNode;
}

// This component won't render children unless show is ever set to true
// Once it render it will hide using opacity/positioning instead of unmounting.
// Warning: could potentially slow down browsers if a ton of content is hidden and not removed
const MountAndHide: React.FC<MountAndHideProps> = ({ children, show }) => {
  const [hasEverShown, setHasEverShown] = useState(show);

  useEffect(() => {
    if (show) {
      setHasEverShown(true);
    }
  }, [show]);

  if (!hasEverShown) {
    return null;
  }

  return (
    <div className={cn("h-full", { "sr-only": !show })} aria-hidden={!show}>
      {children}
    </div>
  );
};

export default MountAndHide;
